import Checkbox from './Checkbox'
import { withCheckbox } from './withCheckbox'

const ConnectedCheckbox = withCheckbox(Checkbox)

export { ConnectedCheckbox as Checkbox }
